export default __webpack_public_path__ + "assets/images/b90e0b5e7ce9b389afe00d9932f49eff.svg";